import { NUMBER } from "../../../constants/app-constants";
import { getFileType } from "../post-inspection-diy/selector";
import { APPLICABLE_RTO_DOC_LIST, DIY_DOCUMENT_VERFIFICATION_STATES } from "../post-inspection-diy/constant";
import PersonalItems from "./images/personalItems.svg";
import FastTag from "./images/fastTag.svg";
import OriginalRc from "./images/original-rc.svg";
import PdfIcon from "./images/pdf.svg";
import DuplicateIcon from "./images/duplicate.svg";
import RtoIcon from "./images/rto.svg";

export const staticDocuments = [
    {
        status: DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED,
        name: "Take out all personal items from the car",
        isRequired: false,
        sampleImage: PersonalItems
    },
    {
        status: DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED,
        name: "Remove FASTag sticker",
        isRequired: false,
        sampleImage: [FastTag]
    },
    {
        status: DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED,
        name: "Submit duplicate key",
        subText: "(if available)",
        isRequired: false,
        sampleImage: [DuplicateIcon]
    },
    {
        status: DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED,
        name: "Submit Original RC",
        subText: "(if available)",
        isRequired: false,
        sampleImage: [OriginalRc]
    }
];

const getFileImageToDisplay = (samples) => {
    if (samples && samples.length) {
        if (getFileType(samples[0]) === "pdf") return PdfIcon;
        return samples[0];
    }
    return PdfIcon;
};

const getRtoOrVehicleDocuments = (doc) => {
    return APPLICABLE_RTO_DOC_LIST.includes(doc.category);
};

const isDocRejected = (status) => {
    return status === DIY_DOCUMENT_VERFIFICATION_STATES.REJECTED;
};

const getBifurcatedDocuments = (documents, isStandAlone) => {
    const rejectedDocList = [];
    const nonRejectedDocList = [];
    const rtoDocList = [];
    let approvedDocCount = 0;
    let rtoRejectedCount = 0;
    documents.forEach((document) => {
        const item = {
            ...document,
            sampleImage: getFileImageToDisplay(document.samples)
        };

        if (item.status === DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED) approvedDocCount += NUMBER.ONE;
        if (isStandAlone && getRtoOrVehicleDocuments(item)) {
            if (isDocRejected(item.status)) rtoRejectedCount += NUMBER.ONE;
            rtoDocList.push(item);
        } else if (isDocRejected(item.status)) {
            rejectedDocList.push(item);
        } else {
            nonRejectedDocList.push(item);
        }
    });
    return {
        rtoRejectedCount,
        rtoDocList,
        rejectedDocList,
        nonRejectedDocList,
        isDocListApproved: approvedDocCount === documents.length
    };
};

const getRtoDocumentDetails = (madatoryDocuments, nonMadatoryDocuments) => {
    const {
        rtoRejectedCount: mandatoryRtoRejectedCount,
        rtoDocList: mandatoryRtoDocuments,
        isDocListApproved: areMandatoryDocumentsApproved
    } = madatoryDocuments;
    const {
        rtoRejectedCount: nonMandatoryRtoRejectedCount,
        rtoDocList: nonMandatoryRtoDocuments,
        isDocListApproved: areNonMandatoryDocumentsApproved
    } = nonMadatoryDocuments;

    const totalRejectedCount = mandatoryRtoRejectedCount + nonMandatoryRtoRejectedCount;
    const list = [...mandatoryRtoDocuments, ...nonMandatoryRtoDocuments];

    if (list && list.length) {
        list.sort((x, y) => {
            return Number(y.rejected) - Number(x.rejected);
        });

        return {
            isAllRtoDocumentsApproved: areMandatoryDocumentsApproved && areNonMandatoryDocumentsApproved,
            isRejectedRtoDocuments: !!totalRejectedCount,
            isRtoDocumentPresent: !!list.length,
            rtoDocument: {
                rejected: !!totalRejectedCount,
                status: totalRejectedCount ? DIY_DOCUMENT_VERFIFICATION_STATES.REJECTED : DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED,
                name: "Sign RTO documents",
                isRequired: false,
                isClickable: true,
                sampleImage: [RtoIcon],
                ...(totalRejectedCount && { verificationComments: [`${totalRejectedCount} DOCUMENTS NOT VERIFIED`] })
            },
            allRtoDocuments: list
        };
    }

    return {};
};

export const getDocumentList = (pickupDocuments = {}, isStandAlone) => {
    const { mandatorySignature = [], nonMandatorySignature = [] } = pickupDocuments;
    const madatoryDocuments = getBifurcatedDocuments(mandatorySignature, isStandAlone);
    const nonMadatoryDocuments = getBifurcatedDocuments(nonMandatorySignature, isStandAlone);
    const {
        rejectedDocList: rejectedMandatoryDocuments,
        nonRejectedDocList: nonRejectedMandatoryDocuments,
        isDocListApproved: areMandatoryDocumentsApproved
    } = madatoryDocuments;
    const {
        rejectedDocList: rejectedNonMandatoryDocuments,
        nonRejectedDocList: nonRejectedNonMandatoryDocuments,
        isDocListApproved: areNonMandatoryDocumentsApproved
    } = nonMadatoryDocuments;

    const {
        rtoDocument,
        allRtoDocuments = [],
        isRejectedRtoDocuments = false,
        isRtoDocumentPresent = false,
        isAllRtoDocumentsApproved = false
    } = getRtoDocumentDetails(madatoryDocuments, nonMadatoryDocuments);
    const docList = [
        ...rejectedMandatoryDocuments,
        ...rejectedNonMandatoryDocuments,
        ...staticDocuments,
        ...nonRejectedMandatoryDocuments,
        ...nonRejectedNonMandatoryDocuments
    ];

    if (isRtoDocumentPresent && isRejectedRtoDocuments) {
        docList.unshift(rtoDocument);
    } else if (isRtoDocumentPresent && !isRejectedRtoDocuments) {
        docList.push(rtoDocument);
    }

    return {
        isMandatoryDocRejected: rejectedMandatoryDocuments.length,
        isNonMandatoryDocRejected: rejectedNonMandatoryDocuments.length,
        areAllDocumentsApproved: areMandatoryDocumentsApproved && areNonMandatoryDocumentsApproved,
        allRtoDocuments,
        docList,
        isRejectedRtoDocuments,
        isAllRtoDocumentsApproved
    };
};
